<template>
 <div>
    <v-card>
      <v-toolbar light prominent flat >
        <v-flex>
          <v-layout row>
            <v-icon light v-html="cxt.getTitleIcon()"></v-icon>
            <v-toolbar-title v-if="!getIsMobile">{{cxt.getTitle()}}</v-toolbar-title>
          </v-layout>
          <v-flex v-if="!getIsMobile" pl-3 class="caption" v-html="formatCountTitle"></v-flex>
          <v-flex v-if="getIsMobile" class="caption" v-html="formatCountTitle"></v-flex>
        </v-flex>
          <v-layout style="overflow:hidden" justify-end>
          </v-layout>
          <v-flex v-show="cxt.isFilterMode()" sm4 xs4>
            <v-text-field
              autofocus
              label="Фильтр"
              v-show="cxt.isFilterMode()"
              :value="cxt.filterString"
              v-on:input="onChangeFilter"
              solo flat
            ></v-text-field>
          </v-flex>
          <span v-show="!cxt.isSelectMode()">
            <span v-show="!cxt.isFilterMode()">
              <v-btn  icon @click="addItem()">
                <v-icon>add</v-icon>
              </v-btn>
            </span>
          </span>
          <v-ops-btn :cxt="cxt" flat></v-ops-btn>
      </v-toolbar>
      <v-progress-linear style="margin-top: 0; margin-bottom: 0" height=2 :active="getItemSet.isProcessing()" :indeterminate="true"></v-progress-linear>
      <v-card-scroll ref="cardScroll" v-on:nextPage="nextPage">
        <v-list
        three-line dense>
          <template v-for="item in this.filteredItems">
            <v-list-tile v-bind:key="getItemKey(item)" @click.stop="cxt.select(getItemKey(item))"
            :value="cxt.activated(getItemKey(item))"
            active-class="v-dealger-favorite-active v-list__tile--highlighted"
            >
              <v-list-tile-content>
                <v-list-tile-title v-html="renderReference(item.ref)"></v-list-tile-title>
                <v-list-tile-sub-title>
                  {{renderHeads(item.ref)}}
                  <br/>
                  ИНН: <span v-html="renderInnOrInnflHtml(item.ref.inn)"></span>
                   <span style="white-space: normal;"> {{formats.blank(item.ref.address)}}</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <span>
                  <v-icon v-show="item.ref.clientId">person</v-icon>
                  <v-icon v-show="!item.ref.clientId"></v-icon>
                  <v-icon v-show="cxt.check(getItemKey(item))">check_box</v-icon>
                  <v-icon v-show="cxt.uncheck(getItemKey(item))">check_box_outline_blank</v-icon>
                  </span>
                </span>
                <div><component :is="renderCompanyFlags(item)"/></div>
                <v-tooltip bottom open-delay="500" max-width="20em">
                  <v-list-tile-action-text slot="activator"><b>{{formats.blank(item.ref.releaseDate, formats.formatDate)}}</b></v-list-tile-action-text>
                  Изменено
                </v-tooltip>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
      </v-card-scroll>
    </v-card>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import classes from '../../api/classes'
  import apimix from '../common/apimix'
  import dialogs from '../common/dialogs'
  import vOpsBtn from '../common/OpsBtn'
  import vCardScroll from '../common/CardScroll'
  import client from '../client/index.js'
  import server from '../../api/server'

  class AddMonitoringAction extends classes.Action {
    constructor (context) {
      super(context,
        'Добавить на Мониторинг',
        null,
        () => this.context.addItem()
        )
    }
  }

  class RemoveMonitoringAction extends classes.Action {
    constructor (context) {
      super(context,
        'Отключить Мониторинг',
        null,
        () => {
          this.context.removeMonitoring(this.context.cxt.selectedIds)
        }
        )
    }
  }
  class SelectAllAction extends classes.Action {
    constructor (context) {
      super(context,
        'Выбрать Всех',
        null,
        () => {
          var fxt = this.context.getItemSet.getFilter()
          server.apiGetParams(
            '/api/me/favorite/companies',
            {
              innOnly: true,
              request: {
                search: fxt.search,
                tagIds: fxt.tagIds,
                isShowOther: false,
                isMonitoring: true
              }
            },
            (data) => {
              context.cxt.selectedIds = data.map(o => o[0])
              console.log('SelectAllAction', context.cxt.selectedIds)
            },
            (e) => {
              context.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка контрагентов клиента  '})
            }
          )
        }
      )
    }
  }

  export default {
    name: 'monitoring-set',
    components: {vOpsBtn, vCardScroll},
    mixins: [apimix],
    data: () => ({
      tags: [],
      cxt: null
    }),
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => this.getItemKey(item))
      })
      cxt.actions.push(new classes.FilterAction(cxt))
      cxt.actions.push(new classes.FilterEndAction(cxt))
      // cxt.actions.push(new classes.ActiveScopeAction(cxt))
      cxt.actions.push(new classes.AllScopeAction(cxt))
      cxt.actions.push({divider: true})
      cxt.actions.push(new classes.SelectAction(cxt))
      cxt.actions.push({divider: true})
      cxt.actions.push(new AddMonitoringAction(this))

      cxt.selectActions.push(new classes.FilterAction(cxt))
      cxt.selectActions.push(new classes.FilterEndAction(cxt))
      cxt.selectActions.push(new RemoveMonitoringAction(this))
      cxt.selectActions.push({divider: true})
      cxt.selectActions.push(new SelectAllAction(this))
      cxt.selectActions.push({divider: true})
      cxt.selectActions.push(new classes.SelectEndAction(cxt))

      cxt.title = 'Мониторинг'
      cxt.titleIcon = 'alarm'
      cxt.selectTitle = 'Выбор контрагента'
      cxt.filterMode = true

      this.cxt = cxt
    },
    mounted () {
      this.fetchData()
      this.setActivated()
    },
    props: {
      itemId: {
        type: String,
        default: null
      },
      tagIds: {
        type: Array,
        default: null
      }
    },
    watch: {
      tagIds: function (newVal, oldVal) {
        if (Array.isArray(newVal)) {
          this.tags = this.getTags.filter(t => newVal.includes(t.id.toString()))
        }
      },
      getTags: function (newVal, oldVal) {
        if (Array.isArray(newVal)) {
          this.tags = this.getTags.filter(t => this.tagIds && this.tagIds.includes(t.id.toString()))
        }
      },
      itemId: function (newVal, oldVal) { // watch it
        this.fetchData()
      },
      getProfileHaveClient: function (newVal, oldVal) { // watch it
        this.fetchData()
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        getItemSet: 'getMonitoredSet',
        getProfileHaveClient: 'getProfileHaveClient',
        getRefToUrl: 'getRefToUrl',
        getTags: 'getTags',
        renderReference: 'renderReference',
        renderHeads: 'renderHeads',
        renderFlags: 'renderFlags',
        renderInnOrInnflHtml: 'renderInnOrInnflHtml'
      }),
      formatCountTitle () {
        var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано '
        if (this.cxt.isSelectMode()) {
          return this.getItemSet.getTotal() > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getItemSet.getTotal() + '' : ''
        } else {
          return this.getItemSet.getTotal() > 0 ? label + this.filteredItems.length + ' из ' + this.getItemSet.getTotal() + '' : ''
        }
      },
      items () {
        return this.getItemSet.getItems()
      },
      orderedItems () {
        return this.items
      },
      filteredItems () {
        const getSearchString = (item) => {
          return ''
            .concat(
              item.ref.caption,
              item.ref.name,
              this.renderHeads(item.ref),
              item.ref.inn,
              item.ref.ogrn,
              item.ref.kpp,
              // this.formatDate(item.ref.createDate),
              // this.formatDate(item.ref.releaseDate),
              item.ref.address,
              item.notes,
              item.privateNotes)
        }
        if ((!this.cxt.isFilterMode()) || (this.cxt.filterString === null)) {
          return this.orderedItems
        }
        let terms = formats.parseSearchTerms(this.cxt.filterString)
        if (terms.length < 1) {
          return this.orderedItems
        }
        return this.orderedItems.filter(item => {
          let searchStr = getSearchString(item).toLowerCase()
          return terms.every(t => (searchStr.includes(t)))
        })
      }
    },
    methods: {
      changeFilterContext (ops, force) {
        this.$store.commit('setMonitoredFilterContext', Object.assign({}, this.getItemSet.getFilter(), ops))
        var self = this
        setTimeout(() => {
          self.$store.dispatch('fetchMonitoredCompanies', force)
          self.scrollToActive()
        }, 500)
      },
      onChangeFilter (e) {
        this.cxt.filterString = e
        if ((this.getProfileHaveClient)) {
          let search = formats.stringifySearchTerms(formats.parseSearchTerms(this.cxt.filterString))
          if (formats.compareString(search, this.getItemSet.getFilter().search) !== 0) {
            this.changeFilterContext({search: search}, true)
          }
        }
      },
      fetchData () {
        if (this.getProfileHaveClient) {
          this.changeFilterContext({tagIds: this.tagIds, search: this.cxt.filterString, isShowOther: false})
          this.$store.dispatch('fetchTags')
        }
      },
      nextPage () {
        this.$store.commit('nextMonitoredCompanies')
        this.$store.dispatch('fetchMonitoredCompanies')
      },
      getItemKey (item) {
        return item ? item.ref.ref : null
      },
      getInnfromKey (key) {
        return key.split('_')[0]
      },
      openItem (id) {
        this.dialogOpen(id)
      },
      addItem () {
        this.selectClient()
      },
      addMonitoring: function (values) {
        if (Array.isArray(values)) {
          var list = values
          this.$store.dispatch('updateMonitoringCompanies', {refCodes: list, monitoring: true})
        }
      },
      removeMonitoring: function (refCodes) {
        if (Array.isArray(refCodes)) {
          dialogs.confirm(this,
          'Подтвердите',
          'Отключить мониторинг для компаний?',
          (self) => {
            self.$store.dispatch('updateMonitoringCompanies', {refCodes: refCodes, monitoring: false})
            self.cxt && self.cxt.toViewMode()
          })
        }
      },
      selectClient () {
        client.selectRef(this, this.addMonitoring, () => {}, null, null, null)
      },
      renderCompanyFlags (item) {
        return this.renderFlags(item.ref.flags)
      },
      scrollToActive () {
        this.$nextTick(() => {
          this.$refs.cardScroll.scrollToListActive()
        })
      },
      setActivated () {
        if (this.$router && this.$router.options && this.$router.options.from) {
          let from = this.$router.options.from
          if (from.params && from.params.clientInn) {
            let itemId = from.params.clientInn
            let item = this.items.find(i => '' + i.ref.ogrn === itemId)
            if (item) {
              this.cxt.activate(this.getItemKey(item))
            } else {
              this.$store.commit('setInfoStatus',
                'Позиционировать не удалось, возможно выборка была изменена. '
              )
            }
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MonitoringSet.vue?b6155ef8